/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ViewChild, HostListener, ComponentRef, ViewContainerRef, Input, ComponentFactoryResolver, Component} from '@angular/core';
import {  Report } from 'src/app/model';
import { InputType } from 'src/app/model/enums/input.type';
import { EntityChargeHoverComponent } from './entity-charge-hover/entity-charge-hover.component';
import { ReportProvider } from 'src/app/providers';
import {LogService } from 'src/app/services';
import {CommaPipe} from "../../../../pipes/comma.pipe";

@Component({
  selector: 'entity-charge',
  templateUrl: 'entity-charge.component.html',
  styleUrls: ['entity-charge.component.scss']
})

export class EntityChargeComponent {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @Input() disabled: boolean;
  @Input() report: Report;

  inputValue = '';
  typeOfInput = InputType;

  private tooltip: ComponentRef<EntityChargeHoverComponent>;
  private visible: boolean;

  constructor(
    private resolver: ComponentFactoryResolver,
    public currencyPipe: CommaPipe,
    public reportProvider: ReportProvider,
    private logService : LogService
  ) {
  }

  @HostListener('mouseenter')
  showInfo(): void {
    if (this.visible || this.disabled)
      return;

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(EntityChargeHoverComponent);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.report = this.report;
  }

  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible)
      return;

    this.saveField();
    this.visible = false;
    if (this.tooltip)
      this.tooltip.destroy();

  }

  saveField(): void {
    this.reportProvider.saveFee(this.report.ID, Number.parseFloat(this.currencyPipe.parse(this.report.CHARGE.toString())), this.report.CHARGE_DESC)
      .subscribe(data => {
        if (!data.success) {
          this.logService.log(data);
        }
      });
  }
}
